class ProductInformationTabs extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === "true") return;

    this.tabs = Array.from(this.querySelectorAll(".product-information-tabs__tab"));
    this.panels = Array.from(this.querySelectorAll(".product-information-tabs__panel"));
    if (!this.tabs.length || !this.panels.length) return;

    this.dataset.initialized = "true";
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", () => this.selectTab(tab));
      tab.addEventListener("keydown", (event) => this.handleKeydown(event));
    });

    this.handleBlockSelect = (event) => {
      const panel = event.target.closest(".product-information-tabs__panel");
      if (!panel || !this.contains(panel)) return;

      const tab = this.tabs.find((item) => item.dataset.productTab === panel.dataset.productPanel);
      if (tab) this.selectTab(tab);
    };
    document.addEventListener("shopify:block:select", this.handleBlockSelect);
  }

  disconnectedCallback() {
    if (this.handleBlockSelect) {
      document.removeEventListener("shopify:block:select", this.handleBlockSelect);
    }
  }

  selectTab(selectedTab, moveFocus = false) {
    const selectedId = selectedTab.dataset.productTab;
    if (moveFocus) selectedTab.focus();

    this.tabs.forEach((tab) => {
      const isSelected = tab === selectedTab;
      tab.classList.toggle("is-active", isSelected);
      tab.setAttribute("aria-expanded", String(isSelected));
      tab.tabIndex = isSelected ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      const isSelected = panel.dataset.productPanel === selectedId;
      panel.classList.toggle("is-active", isSelected);
      panel.hidden = !isSelected;
    });

  }

  handleKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    let nextIndex = currentIndex;

    if (event.key === "ArrowRight") nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === "ArrowLeft") nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === "Home") nextIndex = 0;
    if (event.key === "End") nextIndex = this.tabs.length - 1;
    if (nextIndex === currentIndex) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    this.selectTab(this.tabs[nextIndex], true);
  }
}

if (!customElements.get("product-information-tabs")) {
  customElements.define("product-information-tabs", ProductInformationTabs);
}
